import { createFileRoute } from "@tanstack/react-router";
import { ContactPage } from "@/components/blocks/contact/ContactPage";
import {
	type ContactNeedSlug,
	contactNeedSlugSchema,
	needFromSlug,
} from "@/lib/contact";
import {
	buildPageBreadcrumb,
	buildPageSeo,
	loadPageLocale,
} from "@/lib/page-seo";

export const Route = createFileRoute("/{-$locale}/contact")({
	validateSearch: (search: {
		besoin?: unknown;
	}): { besoin?: ContactNeedSlug } => ({
		besoin: contactNeedSlugSchema.safeParse(search.besoin).data,
	}),
	component: ContactRoute,
	loader: loadPageLocale,
	head: ({ loaderData }) =>
		loaderData
			? buildPageSeo("contact", loaderData.locale, {
					structuredData: [buildPageBreadcrumb(loaderData.locale, ["contact"])],
				})
			: {},
});

function ContactRoute() {
	const { besoin } = Route.useSearch();
	return <ContactPage need={needFromSlug(besoin)} />;
}
